import classnames from 'classnames';
import {
  CKBox,
  CKContainerProps,
  CKLayoutGrid,
  CKLayoutHorizontal,
  includeChildrenByDisplayName,
} from 'clearkit';
import { FC } from 'react';

import { MeterBox } from '../MeterBox';
import { CarouselCardWrapper } from './CarouselCardWrapper';

type ImplementationCardComposition = {
  Heading: FC<CKContainerProps>;
  Description: FC<CKContainerProps>;
  Footer: FC<CKContainerProps>;
};

export type ImplementationCardWrapperProps = {
  forceVisibility?: boolean;
};

type ImplementationCardProps = CKContainerProps & {
  progress: number;
};

export const ImplementationCard: FC<ImplementationCardProps> &
  ImplementationCardComposition = ({
  children,
  className,
  progress,
  ...rest
}) => {
  return (
    <CarouselCardWrapper>
      <CKBox
        {...rest}
        className={classnames(
          className,
          'p-4 h-60 flex flex-col justify-between',
        )}
      >
        <CKLayoutGrid className="mb-4" gridTemplateColumns="auto 1fr">
          <MeterBox
            className="self-start"
            isComplete={progress === 100}
            max={100}
            value={progress}
          />
          <div>
            {includeChildrenByDisplayName({
              children,
              componentDisplayName: 'ImplementationCard.Heading',
            })}
            {includeChildrenByDisplayName({
              children,
              componentDisplayName: 'ImplementationCard.Description',
            })}
          </div>
        </CKLayoutGrid>
        {includeChildrenByDisplayName({
          children,
          componentDisplayName: 'ImplementationCard.Footer',
        })}
      </CKBox>
    </CarouselCardWrapper>
  );
};

ImplementationCard.Heading = ({ children, className, ...rest }) => (
  <h2 {...rest} className={classnames(className, 'font-medium text-lg mb-1')}>
    {children}
  </h2>
);
ImplementationCard.Heading.displayName = 'ImplementationCard.Heading';

ImplementationCard.Description = ({ children, className, ...rest }) => (
  <div
    {...rest}
    className={classnames(className, 'text-gray-800 text-[0.875rem]')}
  >
    {children}
  </div>
);
ImplementationCard.Description.displayName = 'ImplementationCard.Description';

ImplementationCard.Footer = ({ children, ...rest }) => (
  <CKLayoutHorizontal {...rest} as="footer" gap="1.5rem" justifyContent="start">
    {children}
  </CKLayoutHorizontal>
);
ImplementationCard.Footer.displayName = 'ImplementationCard.Footer';
